import chatbotModule from "./chatbotModule";

export default {
  modules: {
    chatbotModule,
  },
};
